




import { Component, Vue, Prop, Ref, Watch } from 'nuxt-property-decorator';
import SearchPackageForm from '~/components/forms/SearchPackageForm.vue';

@Component({
	layout: 'packages',
	components: {
		SearchPackageForm,
	},
})
export default class Funnel extends Vue {

}
